import { Injectable, OnInit } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTableService implements OnInit {

  constructor() { }

  ngOnInit(): void { }
}
